import { useTranslation } from 'react-i18next'
import { Text } from 'rimble-ui'
import styled from 'styled-components/macro'

const DetailsList = styled.ul`
  margin: 0;
  padding-left: 30px;
  margin-bottom: 20px;
`

const StyledDetailsText = styled(Text)`
  font-size: 18px;
  line-height: 1.4;
`

const StakeDetailsList = () => {
  const { t } = useTranslation(['staking'])

  return (
    <DetailsList>
      <li>
        <StyledDetailsText>
          {t('stakeSecurityPopup.details.stakeSmt')}
        </StyledDetailsText>
      </li>
      <li>
        <StyledDetailsText>
          {t('stakeSecurityPopup.details.weeklyShare')}
        </StyledDetailsText>
      </li>
      <li>
        <StyledDetailsText>
          {t('stakeSecurityPopup.details.share')}
        </StyledDetailsText>
      </li>
      <li>
        <StyledDetailsText>
          {t('stakeSecurityPopup.details.earnings')}
        </StyledDetailsText>
      </li>
    </DetailsList>
  )
}

export default StakeDetailsList
